<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10">
      <div class="d-flex align-items-center flex-wrap gap-10">
        <button
          class="default-outline-btn text-black bg-transparent position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block"
          type="button"
          @click="exportExcel"
          v-if="current_permissions('export_transactions')"
        >
          {{ $t('repayments.excel') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
        <div class="position-relative" style="min-width: 220px; max-width: 300px;">
          <input
            v-model="searchQuery"
            type="text"
            class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
            :placeholder="$t('repayments.search')"
          />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          v-if="current_permissions('create_repayment')"
        >
          {{ $t('repayments.createRequest') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('repayments.code') }}
              </th>
              <th v-if="current_permissions('SUPERADMIN')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('repayments.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('repayments.type') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('repayments.initiatedBy') }}
              </th>
              <th v-if="current_permissions('SUPERADMIN')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('repayments.validatedBy') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('repayments.amount') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('repayments.totalFees') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('repayments.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(repayment) in repayments" :key="repayment.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.code }}
              </td>
              <td v-if="current_permissions('SUPERADMIN')" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.organization?.name }}
              </td>
              <td v-if="repayment.type==='BANK'" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ $t('repayments.bankAccount') }}
              </td>
              <td v-if="repayment.type==='CRYPTO'" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ $t('repayments.cryptoAccount') }}
              </td>
              <td v-if="repayment.type==='PAYOUT'" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ $t('repayments.payoutAccount') }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.createdBy?.name }}
              </td>
              <td v-if="current_permissions('SUPERADMIN') && repayment.validatedBy!==null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.validatedBy?.name }}
              </td>
              <td v-if="current_permissions('SUPERADMIN') && repayment.validatedBy===null" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.amount }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ repayment.totalFees }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-info" v-if="repayment.status==='DRAFT'">{{ $t('repayments.pending') }}</span>
                <span class="badge text-outline-success" v-if="repayment.status==='VALIDATED'">{{ $t('repayments.validated') }}</span>
                <span class="badge text-outline-danger" v-if="repayment.status==='REJECTED'">{{ $t('repayments.rejected') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <!-- Le bouton d'action n'apparaît que pour les remboursements en attente (DRAFT) -->
                <button
                  v-if="repayment.status === 'DRAFT'"
                  class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                  type="button"
                  @click="toggleActionsMenu(repayment, $event)"
                >
                  <i class="flaticon-dots"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Menu d'actions téléporté dans le <body> : ne peut plus être masqué
           par le overflow du tableau, quelle que soit la position de la ligne -->
      <Teleport to="body">
        <ul
          v-if="openMenuCode"
          class="dropdown-menu show custom-actions-menu"
          :style="{ top: menuPosition.top + 'px', left: menuPosition.left + 'px' }"
        >
          <li v-if="currentRepayment?.status==='DRAFT' && current_permissions('status_repayment')">
            <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" @click="onActionClick('REJECTED')">
              <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
              <span>{{ $t('repayments.reject') }}</span>
            </a>
          </li>
          <li v-if="currentRepayment?.status==='DRAFT' && current_permissions('status_repayment')">
            <a class="dropdown-item d-flex align-items-center" style="color: green;" href="javascript:void(0);" @click="onActionClick('VALIDATED')">
              <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
              <span>{{ $t('repayments.validate') }}</span>
            </a>
          </li>
          <li v-if="!(currentRepayment?.status==='DRAFT' && current_permissions('status_repayment'))">
            <span class="dropdown-item text-muted">{{ $t('repayments.noAction') }}</span>
          </li>
        </ul>
      </Teleport>

      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('repayments.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('repayments.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('repayments.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('repayments.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('repayments.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('repayments.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create Repayment -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="storeRepayment">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('repayments.repaymentRequest') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div style="margin-bottom: 5%;">
              <h6 class="text-black fw-bold mb-0 text-center">{{ $t('repayments.balance') }}</h6>
              <h6 class="text-black fw-bold mb-0 text-center" style="color: red;">{{ collectBalance?.toLocaleString()}} XOF</h6>
            </div>
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('repayments.repaymentType') }}</label>
                  <select name="mode" id="mode" class="form-select fs-md-15 text-black shadow-none" @change="handleTypeChange" required>
                    <option value="">{{ $t('repayments.select') }}</option>
                    <option value="BANK">{{ $t('repayments.bankAccount') }}</option>
                    <option value="CRYPTO">{{ $t('repayments.cryptoAccount') }}</option>
                    <!-- <option value="PAYOUT">Compte pay out</option> -->
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('repayments.amount') }}</label>
                  <div>
                    <input @keyup="handleAmountChange" v-model="formValues.amount" type="number" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" placeholder="2" @blur="validate('amount')" :class="{ 'is-invalid': errorsBis['amount'] }" />
                    <span class="invalid-feedback">{{ errorsBis['amount']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('repayments.description') }}</label>
                  <div>
                    <textarea v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('repayments.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }">
                    </textarea>
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_repayment')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('repayments.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Country, Fee, Operator, Organization, TypeFree, Repayment, User } from "@/utils/Model";
import { getTypeFee } from "../../utils/services";
import { current_permissions } from '../../utils/permission';
import { showToast, validate_phone_number, checkSessionValidate, formatNumber } from "@/utils/function";
const backApi = inject('back');

const { locale, t } = useI18n();
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedType = ref('');
const selectedMode = ref('');

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const countries = ref(new Array<Country>());
const allRepayments = ref(new Array<Repayment>());

const typeLabelOf = (type: string) =>
  type === 'BANK' ? t('repayments.bankAccount')
    : type === 'CRYPTO' ? t('repayments.cryptoAccount')
    : type === 'PAYOUT' ? t('repayments.payoutAccount')
    : '';

const statusLabelOf = (status: string) =>
  status === 'DRAFT' ? t('repayments.pending')
    : status === 'VALIDATED' ? t('repayments.validated')
    : status === 'REJECTED' ? t('repayments.rejected')
    : '';

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

// Filtrage front sur les mêmes colonnes que le tableau affiché.
const filteredRepayments = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allRepayments.value;
  return allRepayments.value.filter((r: any) => {
    const values = [
      r.code,
      r.organization?.name,
      typeLabelOf(r.type),
      r.createdBy?.name,
      r.validatedBy?.name,
      r.amount,
      r.totalFees,
      statusLabelOf(r.status),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredRepayments.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const repayments = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredRepayments.value.slice(start, start + pageSize.value);
});

let user = {} as User;
const operators = ref(new Array<Operator>());
const collectBalance = ref(0);
let balance: number = 0;
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();
let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'amount': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  amount: "",
  description: ""
});

const schema = yup.object({
  amount: yup.number().required('Le montant est requis'),
  description: yup.string().required('La description est requise'),
});

const openMenuCode = ref<string | null>(null);
const currentRepayment = ref<any>(null);
const menuPosition = reactive({ top: 0, left: 0 });
const MENU_WIDTH = 180;

function toggleActionsMenu(repayment: any, event: MouseEvent) {
  if (openMenuCode.value === repayment.code) {
    closeActionsMenu();
    return;
  }
  const button = event.currentTarget as HTMLElement;
  const rect = button.getBoundingClientRect();

  let left = rect.right - MENU_WIDTH;
  if (left < 8) left = 8;

  menuPosition.top = rect.bottom + 4;
  menuPosition.left = left;

  currentRepayment.value = repayment;
  openMenuCode.value = repayment.code;
}

function closeActionsMenu() {
  openMenuCode.value = null;
  currentRepayment.value = null;
}

function onActionClick(status: string) {
  if (currentRepayment.value) {
    changeStatus(status, currentRepayment.value.code);
  }
  closeActionsMenu();
}

function handleDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (!target.closest('.custom-actions-menu') && !target.closest('.dropdown-toggle')) {
    closeActionsMenu();
  }
}

function handleScrollOrResize() {
  closeActionsMenu();
}

function handleAmountChange(event) {
  let withdrawAmount = event.target.value;
  if (parseFloat(withdrawAmount) <= 0) {
    showToast("Veuillez saisir un montant correct", "red");
    formValues.amount = ''
  }
  if (parseFloat(withdrawAmount) > balance) {
    showToast("Solde insuffisant pour cette opération", "red");
    formValues.amount = ''
  }
}

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}

function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

// Récupère une page depuis l'API (nouvelle forme { data, pagination })
const fetchRepaymentsPage = (targetPage: number) => {
  let baseUrl = '';
  if (
    role === 'SUPERADMIN' ||
    role === 'BUSINESS' ||
    role === 'SUPPORT'
  ) {
    baseUrl = backApi + '/secure/repayments/extended';
  } else {
    baseUrl = backApi + '/secure/repayments/';
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

const loadAllRepayments = async () => {
  try {
    const first = await fetchRepaymentsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchRepaymentsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allRepayments.value = collected;
    data = collected;
    page.value = 1;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

const getBalanceCollect = () => {
  axios.post(backApi + `/secure/accounts/balance/available`, {
    organization: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      collectBalance.value = formatNumber(parseInt(response.data.balance));
      balance = response.data.balance;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/repayments/status`, {
    code: code,
    status: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const storeRepayment = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/repayments/new`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      organization: codeOrganization,
      type: selectedType.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE REVERSEMENT", "TYPE", "MONTANT", "TOTAL FRAIS", "DATE", "STATUT"];
    const Fields = ["code", "type", "amount", "totalFees", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "reversements",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1);
  loadAllRepayments();
  getBalanceCollect();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)

  document.addEventListener('click', handleDocumentClick);
  window.addEventListener('scroll', handleScrollOrResize, true);
  window.addEventListener('resize', handleScrollOrResize);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick);
  window.removeEventListener('scroll', handleScrollOrResize, true);
  window.removeEventListener('resize', handleScrollOrResize);
});
</script>

<style scoped>
.custom-actions-menu {
  position: fixed;
  display: block;
  min-width: 180px;
  z-index: 3000;
  margin: 0;
}
</style>